import { ref } from "vue";
export default {
  name: "LayoutDefault",
  setup: function setup() {
    return {
      leftDrawerOpen: ref(false)
    };
  }
};